import { render, staticRenderFns } from "./SugerenciasPublicas.vue?vue&type=template&id=7297c555&scoped=true"
import script from "./SugerenciasPublicas.vue?vue&type=script&lang=js"
export * from "./SugerenciasPublicas.vue?vue&type=script&lang=js"
import style0 from "./SugerenciasPublicas.vue?vue&type=style&index=0&id=7297c555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297c555",
  null
  
)

export default component.exports